<script setup lang="ts">
const orderHistory = useOrderHistoryStore()
const categoryGroupStore = useCategoryGroup()
const userStore = useUserStore()

const localePath = useLocalePath()
const router = useRoute()
const categoryGroupReverseI18n = useCategoryI18nReverse('enum.product_category_group.')
const currentTab = ref(router.path)

// Category menu

const menuItems = computed(() => {
  const items: any[] = []

  if (orderHistory.totalOrders > 0) {
    items.push({
      to: localePath('/order-history'),
      i18nKey: 'orderHistory.title',
    })
  }

  if (userStore?.data?.clinicChain) {
    items.push({
      to: localePath('/clinic-chain'),
      label: userStore.data.clinicChain.name,
    })
  }

  // Only process category groups if they are loaded and available
  if (!categoryGroupStore.isCategoryGroupsPending && categoryGroupStore.categoryGroup.length > 0) {
    const sortedCategoryGroup = [...categoryGroupStore.categoryGroup].sort(sortByHandle(['pharma', 'practice_supply', 'food']))

    sortedCategoryGroup.forEach((category) => {
      items.push({
        to: localePath(`/${categoryGroupReverseI18n.translateNormalized(category.handle)}`),
        i18nKey: category.i18nKey,
      })
    })
  }

  items.push({
    i18nKey: 'layout.menuSecondary.suppliers',
    to: localePath('/suppliers'),
  })
  items.push({
    to: localePath('/product-favorites'),
    i18nKey: 'layout.menuSecondary.productFavorites',
  })

  items.push({
    to: localePath('/campaigns'),
    i18nKey: 'layout.menuSecondary.campaigns',
  })

  return items
})
</script>

<template>
  <div class="secondary-menu-wrapper">
    <v-container class="d-flex justify-space-between align-center pa-0">
      <v-tabs
        v-model="currentTab"
        class="menu-secondary"
        center-active
        show-arrows
        hide-slider
        height="56"
      >
        <v-tab
          v-for="(item, index) in menuItems"
          :key="index"
          variant="plain"
          size="large"
          class="menu-secondary__tab text-medium-emphasis px-2"
          :href="!item.to && item.path ? item.path : null"
          :to="item.to ? item.to : null"
          :value="item.path || item.to"
          :ripple="false"
          style="opacity: 1;"
        >
          <span v-if="item.i18nKey">{{ $t(item.i18nKey) }}</span>
          <span v-else>{{ item.label }}</span>
        </v-tab>
      </v-tabs>

      <section v-if="userStore?.data?.clinicShortName" class="mr-8">
        <span>{{ userStore.data.clinicShortName }}</span>
      </section>
    </v-container>
  </div>
</template>

<style scoped>
.secondary-menu-wrapper {
  border-bottom: 2px solid rgb(var(--v-theme-red-50));
  height: 56px;
  background-color: white;
}
a,
button {
  color: rgb(var(--v-theme-black-800)) !important;
  letter-spacing: 0px;
  font-weight: 400;
}
</style>
